import React from "react";
import { useTheme } from "styled-components";
var BrandLogo = function BrandLogo(_ref) {
  var color = _ref.color;
  var _useTheme = useTheme(),
    logoSvg = _useTheme.logoSvg,
    colors = _useTheme.colors;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: color !== null && color !== void 0 ? color : colors.text.inverse,
    width: "100%",
    height: "100%",
    viewBox: logoSvg.viewBox,
    dangerouslySetInnerHTML: {
      __html: logoSvg.pathData
    }
  });
};
export default BrandLogo;